import React, { useRef, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import styles from './ProductMediaCarousel.module.scss';
import 'react-image-gallery/styles/css/image-gallery.css';

type MediaItem = {
  thumbnail: string;
  src: string;
  embedUrl?: string;
};

interface IProductMediaCarousel {
  mediaItems: MediaItem[];
}

export const ProductMediaCarousel = ({ mediaItems }: IProductMediaCarousel) => {
  const galleryRef = useRef<HTMLDivElement>(null);
  const [player, setPlayer] = useState<null | any>(null);

  const handleSlideChange = (slideIndex: number) => {
    if (player) {
      player.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
      player.contentWindow.postMessage(JSON.stringify({ method: 'pause', value: true }), '*');
      setPlayer(null);
    }

    const isVideo = Object.keys(mediaItems[slideIndex]).includes('embedUrl');
    if (isVideo) {
      const $slide = galleryRef?.current?.querySelector(`.image-gallery-slide-wrapper .image-gallery-slide:nth-child(${slideIndex + 1}`);
      const $nextPlayer = $slide?.querySelector('iframe');
      // YT
      $nextPlayer?.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
      // Vimeo
      $nextPlayer?.contentWindow?.postMessage(JSON.stringify({ method: 'play', value: true }), '*');
      setPlayer($nextPlayer);
    }
  };
  return (
    <div className={styles.productMediaCarousel} ref={galleryRef}>
      <ImageGallery items={mediaItems} showPlayButton={false} onSlide={handleSlideChange} />
    </div>
  );
};
